<template>
  <div class="table-scroll">
      <table class="table is-striped is-hoverable is-fullwidth">
        <thead>
        <th>ID</th>
        <th>קוד קופון</th>
        <th>סוג</th>
        <th>ימי מתנה - הנחה</th>
        <th>בתוקף עד</th>
        <th>כמות</th>
        <th>נוצר בתאריך</th>
        <th>עריכה</th>
        <th>מחיקה</th>
        <th>השתמשו בקופון</th>
      </thead>
        <tbody>
          <tr v-for="(cupon, index) in cupons" :key="cupon.id">
            <td>{{cupon.id}}</td>
            <td>{{cupon.cupon}}</td>
            <td>{{getCuponType(cupon.type)}}</td>
            <td>{{cupon.free_days}}</td>
            <td>{{cupon.valid_until}}</td>
            <td>{{cupon.qty}}</td>
            <td>{{cupon.createdon}}</td>
            <td>
              <button class="button is-info" @click="editCupon(cupon)">
                ערוך
              </button>
            </td>
            <td><button class="button is-danger"
            @click="deleteCupon(cupon.id, index)">מחק</button></td>
            <td>
              <router-link class="button is-success"
              :to="{name: 'cupon', params: {id: cupon.id}}">לחץ לפירוט</router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
export default {
  props: {
    cupons: Array
  },

  methods: {
    editCupon(cupon) {
      this.$store.dispatch("editCupon", cupon);
    },

    deleteCupon(id, index) {
      const payload = { id, index };
      this.$store.dispatch("deleteCupon", payload);
    },
    getCuponType(type) {
      if (type === 1) {
        return `ימי מתנה`;
      }
      if (type === 3) {
        return `הנחה בתשלום ראשון למנוי שנתי`;
      }
      return `הנחה בתשלום ראשון למנוי חודשי`;
    }
  }
};
</script>

<style>
</style>
